import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

import Header from './header';
import Footer from './footer';

import i18n from '../../i18n';

import './privacyPolicy.css'

export default class PrivacyPolicy extends Component {

    constructor(props) {
        super(props);

        var tLang = 2;
        document.getElementsByTagName("html")[0].setAttribute("lang", "en")
        if (i18n.language == "hr") {
            document.getElementsByTagName("html")[0].setAttribute("lang", "hr")
            tLang = 1;
        }
    }


    render() {
        return (
            <React.Fragment>
                <Header />
                <main>
                    <Container fluid>


                        <br />
                        <br />
                        <br />
                        <br />
                        <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <section>
                                <Container>
                                    <h1>{i18n.t("privacy:naslov")}</h1>
                                </Container>
                            </section>


                            <br />
                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:uvod")}</h2>
                                    <br />

                                    <p>
                                        {i18n.t("privacy:uvod_tekst")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:voditelj_obrade")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:fina")}
                                        <br />
                                        {i18n.t("privacy:adresa")}
                                        <br />
                                        {i18n.t("privacy:sluzbenik")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:svrha")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:svrha_obrade")}
                                    </p>

                                    <p>
                                        {i18n.t("privacy:uredba")}
                                    </p>

                                    <p>
                                        {i18n.t("privacy:obrada_recaptcha")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:osobni_podaci")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:korisnik_aplikacije")}
                                    </p>

                                    <p>
                                        {i18n.t("privacy:podaci_korisnika")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:primatelji_podataka")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:drugi_primatelji")}
                                    </p>
                                    <p>
                                        {i18n.t("privacy:primatelji_podataka_tekst")}
                                    </p>
                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:rok_pohrane")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:rok_pohrane_tekst")}
                                    </p>
                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:prava_ispitanika")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:ispitanici_prava")}
                                    </p>

                                    <p>
                                        {i18n.t("privacy:ispitanici_prigovor")}
                                    </p>
                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("privacy:izmjena")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("privacy:izmjena_tekst")}
                                    </p>
                                    <br />
                                </Container>
                            </section>

                        </div>
                        <br />

                    </Container >
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}